module.exports = __webpack_public_path__ + "a071be2ba3c8773728a62ab4ac9dc1af.png";